export const DRAG_HANDLER_CLASSNAME = 'dragHandler';
